import { every, get } from 'lodash-es';
import moment from 'moment';

export function getAdjustedDateRangeValues(
  fieldName,
  parsedDate,
  currentValues,
  { startField, endField }
) {
  const otherFieldName = fieldName === startField ? endField : startField;
  const otherDate = currentValues[otherFieldName];

  const updatedValues = { [fieldName]: parsedDate };

  if (otherDate && parsedDate) {
    if (fieldName === startField && parsedDate.isAfter(otherDate, 'day')) {
      updatedValues[endField] = parsedDate;
    } else if (
      fieldName === endField &&
      parsedDate.isBefore(otherDate, 'day')
    ) {
      updatedValues[startField] = parsedDate;
    }
  }

  return updatedValues;
}

export function isDateRangeEqual(range1, range2) {
  return every(['from', 'to'], key => {
    const m1 = get(range1, key);
    const m2 = get(range2, key);
    if (!moment.isMoment(m1) && !moment.isMoment(m2)) {
      return true;
    }
    if (moment.isMoment(m1) && moment.isMoment(m2)) {
      return m1.isSame(m2, 'day');
    }
    return false;
  });
}
